import { Component, OnInit, OnDestroy, HostListener, ElementRef, Input  } from '@angular/core';
import { LogoService } from '../data/logo.service';



@Component({
  selector: 'app-floatingimage',
  templateUrl: './floatingimage.component.html',
  styleUrls: ['./floatingimage.component.css']
})
export class FloatingimageComponent implements OnInit {
     
    @Input() prodId: any;

  data: any;
  logo :any;
  device : string;

    model = {
        left: true,
        middle: false,
        right: false
    };
    date : Date = new Date();

     constructor(public el: ElementRef,private logos: LogoService) { }

     @HostListener('window:scroll', ['$event'])
     checkScroll() {
        const componentPosition = document.getElementsByClassName('add-animation');
        const scrollPosition = window.pageYOffset;
        
        for(var i = 0; i < componentPosition.length; i++) {
            var rec = componentPosition[i].getBoundingClientRect().top + window.scrollY + 100;
            if ( scrollPosition + window.innerHeight >= rec ) {
                componentPosition[i].classList.add('animated');
            } else if ( scrollPosition + window.innerHeight * 0.8 < rec ) {
                componentPosition[i].classList.remove('animated');
            }
        }
     }
    ngOnInit() {
        
        this.getData();
        this.logo = this.data[this.prodId];
        var body = document.getElementsByTagName('body')[0];
        body.classList.add('presentation-page');
        body.classList.add('loading');
        var navbar = document.getElementsByTagName('nav')[0];
        navbar.classList.add('navbar-transparent');

 
    }
    ngOnDestroy(){
        var body = document.getElementsByTagName('body')[0];
        body.classList.remove('presentation-page');
        body.classList.remove('loading');
        var navbar = document.getElementsByTagName('nav')[0];
        navbar.classList.remove('navbar-transparent');
    }

  getData(): void {
    this.logos.getLogoData().subscribe( data => this.data = data );
  }


}
